
(function(){

    //
    // Set the log function
    //
    if(ws.portal_environment === 'portal'){
        console.logdev = function(){};
        return;
    }

    console.logdev = function(){
        let colors = 'color: #57a020';
        console.log('%c🐵🐵🐵', colors, ...arguments);
    };

})(); // End auto-executable anonymous function


